module.exports = __webpack_public_path__ + "img/pinterest.0b397031.svg";